import { specialCharMap } from "@testing-library/user-event/dist/keyboard";
import React, { useState } from "react";

const LabledInput = ({
  label,
  type = "text",
  value,
  name,
  onChange,
  placeholder,
  required = false,
  min,
  max,
  pattern,
  errorMessage = "",
  containerClassName = "",
  labelClassName = "",
  inputClassName = "",
  errorClassName = "",
  inlineLabel = false,
  disabled = false,
  specialLabel = null,
  maxLength = undefined,
}) => {
  const [error, setError] = useState("");

  const handleValidation = (inputValue) => {
    // Trim string values
    const trimmedValue =
      typeof inputValue === "string" ? inputValue.trim() : inputValue;

    // Required
    if (required && !trimmedValue) {
      setError("This field is required");
      return;
    }

    // Min/Max (numbers)
    if (type === "number") {
      const numValue = Number(trimmedValue);
      if (min !== undefined && numValue < min) {
        setError(`Value should be at least ${min}`);
        return;
      }
      if (max !== undefined && numValue > max) {
        setError(`Value should not exceed ${max}`);
        return;
      }
    }

    // Pattern
    if (pattern && !new RegExp(pattern).test(trimmedValue)) {
      setError(errorMessage || "Invalid format");
      return;
    }

    // All good!
    setError("");
  };

  return (
    <div
      className={`flex flex-col lg:flex-row space-y-2 lg:space-y-0 items-stretch lg:items-end w-full lg:w-5/6
       ${containerClassName}`}
    >
      {label && (
        <span className="font-be-jost-pro font-medium text-white text-sm w-full lg:w-[15%]">
          {`${label}:`}
          {inlineLabel && ":"}
        </span>
      )}
      <div className="flex items-center gap-1 w-full">
        {specialLabel && (
          <span className="text-[#808080] py-1">{specialLabel}</span>
        )}
        <input
          disabled={disabled}
          id={name}
          type={type}
          name={name}
          value={value}
          maxLength={maxLength}
          onChange={(e) => {
            onChange(e);
            handleValidation(e.target.value);
          }}
          onWheel={(e) => e.target.blur()} // <-- Prevent scroll change
          placeholder={placeholder}
          className={`bg-[#0c0b0b] ${
            disabled ? "text-gray-400" : "text-white"
          } border-b px-2 py-1 w-full ${inputClassName}`}
          min={type === "number" ? min : undefined}
          max={type === "number" ? max : undefined}
        />
      </div>
      {error && (
        <p className={`text-red-500 text-xs mt-1 ${errorClassName}`}>{error}</p>
      )}
    </div>
  );
};

export default LabledInput;
